// extracted by mini-css-extract-plugin
module.exports = {"topDiv":"loginFromWebsite_topDiv__2S4uw","loaderTextDiv":"loginFromWebsite_loaderTextDiv__1O0q6"};